import { Stack } from '@mui/material';

import { useMatchingRoutes } from '@/hooks/useMatchingRoutes';
import { useRequiredParam } from '@/hooks/useRequiredParam';
import { AISuggestionReviewProcessingBanner } from '@/modules/aiSuggestionReviewCard/components/AISuggestionReviewProcessingBanner';
import { ReviewSuggestionsBannerEntryPoint } from '@/modules/aiSuggestions/reviewSuggestions/ReviewSuggestionsBannerEntryPoint';
import { useValidationQuestionsState } from '@/modules/validationQuestions/hooks/useValidationQuestionsState';
import { useIsHouseholdWorkflowTrackerInProgress } from '@/modules/workflowTrackers/hooks/useIsHouseholdWorkflowTrackerInProgress';
import { ROUTE_KEYS } from '@/navigation/constants';
import { WorkflowTrackerKind } from '@/types/schema';

export function EstateOnboardingSuggestionsBanner() {
  const householdId = useRequiredParam('householdId');
  const { isWaitingForAnswers } = useValidationQuestionsState(householdId);
  const isAIOnboardingWorkflowInProgress =
    useIsHouseholdWorkflowTrackerInProgress(
      WorkflowTrackerKind.DocumentExtraction
    );

  const isHouseholdRegenInProgress = useIsHouseholdWorkflowTrackerInProgress(
    WorkflowTrackerKind.AiSuggestionsV2HouseholdRegen
  );

  const { isMatchingRoute: isOnBalanceSheet } = useMatchingRoutes([
    ROUTE_KEYS.HOUSEHOLD_ESTATE_BALANCE_SHEET,
  ]);

  const showProcessingBanner =
    !isWaitingForAnswers &&
    (isAIOnboardingWorkflowInProgress || isHouseholdRegenInProgress);

  if (!showProcessingBanner) {
    return isOnBalanceSheet ? (
      <ReviewSuggestionsBannerEntryPoint mountTrowser={false} />
    ) : null;
  }

  return (
    <Stack direction="column" gap={2}>
      {isAIOnboardingWorkflowInProgress && (
        <AISuggestionReviewProcessingBanner suggestionTypeText="data" />
      )}
      {!isAIOnboardingWorkflowInProgress && isHouseholdRegenInProgress && (
        <AISuggestionReviewProcessingBanner
          suggestionTypeText="suggestions"
          isHouseholdRegen
        />
      )}
      {isOnBalanceSheet && (
        <ReviewSuggestionsBannerEntryPoint mountTrowser={false} />
      )}
    </Stack>
  );
}
